import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { isSameProfessionalPage } from './routes/routeConfig';
import UnsavedChangesGuard from './components/UnsavedChangesGuard';
import { ViewProvider } from './context/ViewContext';
import { ActiveBusinessProvider } from './hooks/useActiveBusiness';
import DiscoverySite from './pages/discovery/DiscoverySite';
import { DiscoveryStatusProvider } from './hooks/useDiscoveryStatus';
import { isDiscoveryHost } from './constants/discovery';

function App() {
  const onDiscoveryHost = isDiscoveryHost();
  const isLocalDiscoveryPreview = process.env.NODE_ENV !== 'production' &&
    typeof window !== 'undefined' && /^\/discovery\/?$/.test(window.location.pathname);
  if (onDiscoveryHost || isLocalDiscoveryPreview) {
    return (
      <DiscoveryStatusProvider>
        <Router>
          <DiscoverySite isDiscoveryHost={onDiscoveryHost} />
        </Router>
      </DiscoveryStatusProvider>
    );
  }

  return (
    <DiscoveryStatusProvider>
      <ViewProvider>
        <Router>
          <ActiveBusinessProvider>
            <UnsavedChangesGuard isSamePage={isSameProfessionalPage}>
              <AppRoutes />
            </UnsavedChangesGuard>
          </ActiveBusinessProvider>
        </Router>
      </ViewProvider>
    </DiscoveryStatusProvider>
  );
}

export default App;
